<template>
  <div id="app">
    <div class="login">
      <div class="login_bg">
        <div class="mask_layer" style="position: relative;">
          <img src="../assets/img/bg2.png" style="margin-top: px; height: 800px;">
          <div class="login_box" style="position: absolute; top: 440px; left: 50%; transform: translateX(-50%);">
            <img src="../assets/img/logo.jpg" alt="" class="logo"
                 style="position: absolute; top: -60px; left: 50%; transform: translateX(-50%); height: 50px;">
            <div>Logging in .........</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
export default {
    data() {
        return {
        }
    },
    mounted() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      let loginSecert = urlParams.get('loginSecert');
      if (!loginSecert) {
        this.$message({
          type: 'error',
          message: 'error！'
        })
        return;
      }
      this.login(loginSecert)
    },
    methods: {
        login(loginSecretCode) {
            const url = '/manage/yeseu/login_tpa';
            let params = {loginSecretCode:loginSecretCode}
            this.$request({
                url: url,
                method: 'post',
                data: params
            }).then(res =>{
                console.log('Response=>',res);
                if (res.data.result == 0) {
                    this.$store.state.user = res.data.obj;
                    // console.log('store===>',this.$store.state.user);
                    // 第一次登录成功，密码进行加密
                    sessionStorage.setItem('userName', res.data.obj.userName);
                    sessionStorage.setItem('userType', res.data.obj.userType)
                    sessionStorage.setItem("id", res.data.obj.id)
                    sessionStorage.setItem("roleId", res.data.obj.roleId)
                    sessionStorage.setItem("roleName", res.data.obj.roleName)

                    sessionStorage.setItem('permissionIds', res.data.obj.permissionIds)
                    setTimeout(()=>{
                      this.$router.push('/home')
                    },500)
                    console.log('Vuex:state=>',this.$store.state.user);
                    console.log('Vuex:state=>',this.$store.state);

                    console.log('Vuex:type=>',this.$store.state.user.userType);
                    this.$message({
                        type: 'success',
                        message: res.data.msg
                    });
                } else {
                    this.$message({
                        type: 'info',
                        message: res.data.msg
                    });

                    console.log("login result")
                }
            }).catch((err) => {
                console.log(err);
                // console.log('Login failed');
                this.$message({
                    type: 'error',
                    message: 'login failed: ' + err.message
                })
            })
        },
    }
}
</script>

<style lang="scss" scoped>
#app {

    width: 100%;
    height: 100vh;

    .login {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: flex-end;

        .login_bg {
            width: 100%;
            height: 100%;
            background: url('@/assets/img/bg.jpg') no-repeat;
            background-size: cover;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;

            .mask_layer {
                .logo {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }

            }

        }


    }
}
</style>
